/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { ComponentBase, IForm } from 'app/shared/lib/essette-site';
import { SystemReviewService } from 'app/cm/services/system-review-service';
import { apiCall } from 'app/shared/lib/essette-api';
import { Toaster } from 'app/shared/lib/toaster';
import * as CM from 'app/cm/models/essette-api';

@autoinject()
export class SaveIllness extends ComponentBase implements IForm {

  ////****************** Fields and Properties ************************************////
  public illnessId: string = '';
  public illnessText: string = '';
  public systemId: string = '';

  ////****************** Lifecycle events (in order of execution) *****************////
  constructor(
    private readonly service: SystemReviewService,
    private readonly toaster: Toaster,
    ...rest: any[]) {
    super(...rest);
  }

  ////****************** Events ***************************************************////

  ////****************** Functions ************************************************////
  protected buildIllness(): CM.SystemIllness {
    const saveIllness: CM.SystemIllness = {
      id: this.illnessId,
      description: this.illnessText,
      code: null,
      system: {
        id: this.systemId
      }
    };

    return saveIllness;
  }

  ////****************** IForm ****************************************************////
  public hasChanges(): boolean {
    throw new Error('Method not implemented.');
  }

  public async submit(): Promise<boolean> {
    const isSuccess = await this.saveIllness();
    return isSuccess;
  }

  ////****************** Service Calls ********************************************////
  @apiCall
  protected async saveIllness(): Promise<boolean> {

    const insertIllness: CM.SystemIllness = this.buildIllness();

    let isSuccessful = false;
    try {
      this.state.beginSave();
      const response = await this.service.saveSystemIllness(insertIllness);
      isSuccessful = response.isSuccessful;

      return isSuccessful;
    }
    catch(error) {
      throw error;
    }
    finally {
      if(this.illnessId) {
        this.toaster.standard.updated('cm:systemIllness.$', isSuccessful);
      } else {
        this.toaster.standard.created('cm:systemIllness.$', isSuccessful);
      }
      this.state.endSave();
    }
  }
}
